import LoLExamList from './LoLExamList';

export default LoLExamList;
